<template>
  <div 
    class="context-menu-item cpt-menu-text-button" 
    :class="[
      data.type,
      {
        'selected': data.selected,
        'disable': data.disable,
        'height50': data.height50,
        'gradient': data.gradient
      }
    ]"
    :style="{ color: data.color ? data.color : '' }" 
    @click.prevent="clickHandler"
  >
    <div class="icon" v-if="data.image">
      <ChatImg :src="data.image" :webp_quality="30" thumbnail="48x"/>
    </div>
    <div class="icon" v-if="data.icon">
      <span :class="['iconfont', data.icon]" :style="{'background-image': data.gradient || '' }"></span>
    </div>
    <p class="label" v-html="purifyHTML(data.label)" :style="{'background-image': data.gradient || '' }"></p>
  </div>
</template>

<script>
import { purifyHTML } from '_lib/purify';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    group_index: {
      type: Number,
      default: 0
    },
    cpt_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    clickHandler (e) {
      if (this.data.disable) return
      if (this.$parent.cptMenuButtonClick) {
        this.$parent.cptMenuButtonClick(this.group_index, this.cpt_index, e)
      } else if (this.data.onClick) {
        this.data.onClick(this.data)
      }
    },
    purifyHTML,
  }
}
</script>

<style lang="scss">
.cpt-menu-text-button {
  max-width: 478px;
  height: 32px;
  padding: 0 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: $d-tx-2;
  border-radius: 5px;
  // transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
  &.height50 {
    height: 50px;
  }
  &:hover {
    background: $d-bd-fl;
    color: $ct-wh-0!important;
  }
  &.warn{
    color: $d-er-tx;
    &:hover {
      background: $d-er-fl;
    }
  }
  &.confirm{
    color: $d-bd-tx;
    &:hover {
      background: $d-bd-fl;
      color: $ct-wh-0!important;
    }
  }
  &.selected {
    .icon .iconfont, .label {
      font-weight: 700;
      color: $d-tx-1;
    }
  }
  &.disable {
    cursor: not-allowed;
    color: $d-tx-2;
    img {
      filter: grayscale(1);
    }
  }
  &.gradient {
    .icon .iconfont, .label {
      color: transparent;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    position: relative;
    flex-shrink: 0;
    .iconfont, .cpt-chat-img {
      width: 16px;
      height: 16px;
      position: absolute;
      font-size: 16px;
    }
    .cpt-chat-img {
      border-radius: 50%;
    }
  }
  .label {
    font-size: 14px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    p {
      color: $d-tx-3;
      font-size: 12px;
      line-height: 20px; 
    }
  }
}
</style>